import { render, staticRenderFns } from "./ErrorField.vue?vue&type=template&id=80548800"
import script from "./ErrorField.vue?vue&type=script&lang=js"
export * from "./ErrorField.vue?vue&type=script&lang=js"
import style0 from "./ErrorField.vue?vue&type=style&index=0&id=80548800&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports